// extracted by mini-css-extract-plugin
export default {"searchFilters":"SearchFilters_searchFilters__4eX7n","subjects":"SearchFilters_subjects__G1o6r"};